import React, {
  useEffect,
  useState,
  createContext,
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

import * as AuthUtils from '../../utils/auth';
import * as LivenessUtils from '../../utils/liveness';

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [status, setStatus] = useState();
  const [token, setToken] = useState();
  const [profile, setProfile] = useState();
  const [flow, setFlow] = useState();
  const [step, setStep] = useState();
  const [cardConfig, setCardConfig] = useState();
  const [process, setProcess] = useState();
  const [flowProcess, setFlowProcess] = useState();
  const [company, setCompany] = useState();
  const [clientData, setClientData] = useState({});
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [stepConfig, setStepConfig] = useState();
  const [livenessNode, setlivenessNode] = useState();
  const [participantEmail, setParticipantEmail] = useState();
  const [participantName, setParticipantName] = useState();
  const [participantPhone, setParticipantPhone] = useState();

  const fillStates = async () => {
    setStatus(await AuthUtils.getStatus());
    setToken(await AuthUtils.getToken());
    setProfile(await AuthUtils.getProfile());
    setFlow(await AuthUtils.getFlow());
    setStep(await AuthUtils.getStep());
    setCardConfig(await AuthUtils.getCardConfig());
    setProcess(await AuthUtils.getProcess());
    setFlowProcess(await AuthUtils.getFlowProcess());
    setCompany(await AuthUtils.getCompany());
    setEmail(await AuthUtils.getEmail());
    setName(await AuthUtils.getName());
    setStepConfig(await AuthUtils.getStepConfig());
    setlivenessNode(await AuthUtils.getlivenessNode());
    setParticipantEmail(await LivenessUtils.getParticipantEmail());
    setParticipantName(await LivenessUtils.getParticipantName());
    setParticipantPhone(await LivenessUtils.getParticipantPhone());
  };

  useEffect(() => {
    fillStates();
  }, []);

  const removeData = useCallback(() => {
    setStatus(null);
    setToken(null);
    setProfile(null);
    setFlow(null);
    setStep(null);
    setProcess(null);
    setFlowProcess(null);
    setCompany(null);
    setEmail(null);
    setName(null);
    setStepConfig(null);
    setlivenessNode(null);
    setParticipantEmail(null);
    setParticipantName(null);
    setParticipantPhone(null);
  }, []);

  const setLivenessData = useCallback((livenessData = {}) => {
    const {
      participantEmail: _participantEmail,
      participantName: _participantName,
      participantPhone: _participantPhone,
    } = livenessData;

    setParticipantEmail(_participantEmail);
    setParticipantName(_participantName);
    setParticipantPhone(_participantPhone);
  }, []);

  const setLoginData = useCallback((loginData = {}) => {
    const {
      status: _status,
      flow: _flow,
      company: _company,
      token: _token,
      profile: _profile,
      step: _step,
      process: _process,
      flowProcess: _flowProcess,
      clientData: _clientData,
      cardConfig: _cardConfig,
      email: _email,
      name: _name,
      stepConfigId: _stepConfig,
      livenessNode: _livenessNode,
    } = loginData;

    setStatus(_status);
    setToken(_token);
    setProfile(_profile);
    setFlow(_flow);
    setStep(_step);
    setCardConfig(_cardConfig);
    setProcess(_process);
    setFlowProcess(_flowProcess);
    setCompany(_company);
    setEmail(_email);
    setName(_name);
    setStepConfig(_stepConfig);
    setlivenessNode(_livenessNode);
    if (_clientData) setClientData(_clientData);
  }, []);

  const value = useMemo(
    () => ({
      status,
      profile,
      flow,
      step,
      cardConfig,
      process,
      flowProcess,
      company,
      email,
      name,
      stepConfig,
      clientData,
      isAuth: Boolean(token),
      livenessNode,
      participantEmail,
      participantName,
      participantPhone,
      setLoginData,
      removeData,
      setLivenessData,
    }),
    [
      status,
      profile,
      flow,
      step,
      cardConfig,
      process,
      flowProcess,
      company,
      email,
      name,
      stepConfig,
      clientData,
      token,
      livenessNode,
      participantEmail,
      participantName,
      participantPhone,
      setLoginData,
      removeData,
      setLivenessData,
    ],
  );

  return (
    <AuthContext.Provider value={value}>
      { children }
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
